import React, { useState } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import Details from '../../DeviationViews/Details';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import UserGiftSaleBanner from '../_partials/UserGiftSaleBanner';
import DesktopLayout from '../_partials/DesktopLayout';
import MonetizationBanner from '../../banners/MonetizationBanner';

import s from './DesktopDeviationPage.scss';

export interface Props {
  deviation: PapiDeviation;
}

const DesktopDeviationPage: React.FC<Props> = ({ deviation }) => {
  // we'll force a re-render of the page when a countdown in the offer banner of the monetization strip
  // reaches 0 (onAdoptableSaleEnd). This will update the actionbar to change from the 'make an offer'
  // button to the 'view offers' button to show the sale is over
  const [hasAdoptionEnded, setHasAdoptionEnded] = useState(false);

  return (
    <DesktopLayout
      deviation={deviation}
      stageContent={
        <>
          <ArtStage deviation={deviation} />
          <div className={s['monetization-strip-wrapper']}>
            <MonetizationBanner
              className={s['monetization-strip']}
              deviation={deviation}
              onAdoptableSaleEnd={() => setHasAdoptionEnded(true)}
            />
          </div>
          <ActionBar
            // maintain a key so we can force a re-render
            key={`actionbar-${hasAdoptionEnded}`}
            deviation={deviation}
          />
        </>
      }
      metaContent={
        <>
          <Details contentClassName={s['details']} deviation={deviation} />
          <UserGiftSaleBanner user={deviation.author} />
        </>
      }
      withSecondaryActionBar={[DeviationTypes.JOURNAL].includes(
        getDeviationType(deviation)
      )}
    />
  );
};
DesktopDeviationPage.displayName = 'DesktopDeviationPage';

export default DesktopDeviationPage;
